<template>
  	<div class="stores" @click='topHide' style="height:100%">
    	<div class="breadcrumb">课程管理 > 课程列表</div>
        <div class="hall-search-list">
			<el-button size='small' type="primary" @click="add" plain v-has="'course_list_add'">新增</el-button>
			<span class="hall-search-name">课程名称：</span>
            <input type="text" style="width:300px;" placeholder="请输入课程名称" class="el-input__inner" v-model="courseName" @keyup.enter="search_mine()"/>
            <span class="hall-search-name">教练选择：</span>
			<el-select v-model="coachId" placeholder="请选择" @change="search_mine">
				<el-option label="全部" value=""></el-option>
                <el-option
                    v-for="item in coachesData" 
                    :key="item.id"
                    :label="item.coachName"
                    :value="item.id">
                </el-option>
            </el-select>
            <span class="hall-search-name">课程时间：</span>
            <el-date-picker
                v-model="timeVal"
                type="daterange"
                range-separator=" 至 "
                start-placeholder="课程开始日期"
                end-placeholder="课程结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
            <span class="hall-search-line"></span>
	    	<el-button type="primary" @click="search_mine()">搜索</el-button>
		</div>
        <div style="padding:10px 0">
            <el-tabs v-model="activeName" @tab-click="topnav">
                <el-tab-pane label="全部" name="-1"></el-tab-pane>
                <el-tab-pane v-for="(item,index) in selData" :key="index" :label="item.name" :name="index+''"></el-tab-pane>
             </el-tabs>
        </div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" border :data="tableData" style="width: 100%" @current-change="handleCurrentChange" :row-class-name="tableRowClassName" header-cell-class-name="table-header">
			        <el-table-column prop="coachName" label="课程教练" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="name"  label="课程名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="tss"  label="训练压力" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="vi"  label="强度因子" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="calories"  label="课程消耗" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="sportKindName"  label="运动类型名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="beginTime"  :formatter="this.global.dateFormat" label="课程开始时间" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="courseDuration" label="课程时长(分钟)" show-overflow-tooltip></el-table-column>
			        <el-table-column label="操作" width="280" align="center">
			        	<template slot-scope="scope">
                            <el-button v-if="hasshow"
                                    @click="videoStick(scope.row)"
                                    type="text"
                                    size="small"
                                    icon="el-icon-s-claim">{{scope.row.setTop==1?' 取消置顶':'置顶'}}</el-button>
                            <el-button v-has="'course_list_stage'"
                                    @click="stage(scope.row)"
                                    type="text"
                                    size="small"
                                    icon="el-icon-s-claim">阶段</el-button>
                            <el-button 
                                    v-if="scope.row.returnCourse!=1"
                                    v-has="'course_list_reorganized'"
                                    @click="courseEncore(scope.row)"
                                    type="text"
                                    size="small"
                                    icon="el-icon-s-claim">重新编排</el-button>
                            <el-button v-has="'course_type_update'"
                                    @click="edit(scope.row.id)"
                                    type="text"
                                    size="small"
                                    icon="el-icon-s-order">编辑</el-button>
                            <el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id)"> 
                                <el-button v-has="'course_type_delete'" 
                                    slot="reference"
                                    type="text"
                                    size="small"
                                    style="color:red;"
                                    icon="el-icon-delete">删除</el-button>
                            </el-popconfirm>
                            <el-switch
                                v-has="'course_switch'" 
                                v-model="scope.row.visibility == 0 ? true : false"
                                active-color="#13ce66"
                                inactive-color="#eeeeee"
                                active-text="上架"
                                inactive-text="下架"
                                @change="updatesw(scope.$index, scope.row.id, scope.row.visibility)"
                            >
                            </el-switch>
                        </template>
			        </el-table-column>
		        </el-table>
	      	</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	    </div>
	    <!-- 添加修改弹框 -->
	    <el-dialog title="提示" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" top="10px" :close-on-click-modal="false">
	      	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="140px">
		        <el-form-item label="课程名字" prop="name">
		          	<el-input v-model="ruleForm.name" placeholder="请输入课程名字" style="width: 80%;" :disabled="is_director"></el-input>
		        </el-form-item>
                <el-form-item label="课程背景色" prop="backcolor">
                  <el-radio-group v-model="ruleForm.backcolor">
                    <el-radio :label="1">浅色</el-radio>
                    <el-radio :label="2">深色</el-radio>
                  </el-radio-group>
		        </el-form-item>
	        	<!-- 选择用户 -->
	        	<el-form-item label="请选择教练" prop="coachIds" class="selectUser" >
	          		<!-- <i class="el-icon-edit" :disabled="true"></i>
	          		<label @click="selCoachesDialog()">{{ruleForm.coachName}}</label> -->
                    <div style="padding:4px 0 10px 0;">
                        <el-tag style="margin:6px 6px 0 0;" v-for="tag in coachesChoice" :key="tag.id" closable @close="coachesChoiceMethod(tag.id)">{{tag.coachName}}</el-tag>
                    </div> 
                    <el-popover
                        placement="right"
                        width="600"
                        trigger="click">
                        <div class="coursesList-group Scrollbars-box" style="max-height:400px;">
                            <el-checkbox-group v-model="checkCoachesList" @change="ruleForm.coachIds=checkCoachesList.join(',')">
                                <el-checkbox :label="item.id" v-for="item in coachesData" :key="item.id">
                                        <img :src="item.coachAvatar" alt="">
                                        <span>{{item.coachName}}</span>
                                    </el-checkbox>
                            </el-checkbox-group>
                        </div>
                         <el-button slot="reference">选择教练</el-button>
                    </el-popover>
                    <el-input v-model="ruleForm.coachIds" type="hidden"></el-input> 
	        	</el-form-item>
                <el-form-item label="直播课" prop="liveChargeStatus">
                  <el-radio-group v-model="ruleForm.liveChargeStatus">
                    <el-radio :label="1">免费</el-radio>
                    <el-radio :label="0">VIP</el-radio>
                  </el-radio-group>
		        </el-form-item>
                <el-form-item label="点播课" prop="chargeStatus" @change="ruleForms.freeStartTime[0].required=(ruleForm.chargeStatus==1?true:false)">
                  <el-radio-group v-model="ruleForm.chargeStatus">
                    <el-radio :label="1">限免</el-radio>
                    <el-radio :label="0">VIP</el-radio>
                  </el-radio-group>
		        </el-form-item>
                <el-form-item label="点播课限免时间" prop="freeStartTime" v-if="ruleForm.chargeStatus == 1">
                  <el-date-picker
                        style="width:400px;"
                        v-model="freetimeVal"
                        @change="ruleForm.freeStartTime=freetimeVal[0]"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="课程开始时间"
                        end-placeholder="课程结束时间"
                        value-format="timestamp">
                    </el-date-picker >
                    <el-input v-model="ruleForm.freeStartTime" type="hidden"></el-input> 
		        </el-form-item>
                <el-form-item label="课程强度" prop="courseIntensityId">
		          	<el-select v-model="ruleForm.courseIntensityId" placeholder="请选择课程强度" style="width: 80%;" :disabled="is_director">
		            	<el-option v-for="item in intensityData" :key="item.id" :label="`${item.name}(${item.viFrom}~${item.viTo})`" :value="item.id"></el-option>
		          	</el-select>
		        </el-form-item>
		        <el-form-item label="课程标签">
                  <el-checkbox-group v-model="courseTagVosList" @change="courseTagVosMethod">
                        <el-checkbox :label="item.id" v-for="item in courseTagVosData" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
		        </el-form-item>
		        <el-form-item label="运动类型" prop="sportsKindId">
		          	<el-select v-model="ruleForm.sportsKindId" placeholder="请选择运动类型" style="width: 80%;" @change="rulesportKindId" :disabled="is_director">
		            	<el-option v-for="item in selData" :key="item.id" :label="item.name" :value="item.id" >{{item.name}}</el-option>
		          </el-select>
		        </el-form-item>
		        <el-form-item label="课程类型">
		          	<el-select v-model="ruleForm.kindId" placeholder="请选择" style="width: 80%;" :disabled="is_director">
		            	<el-option v-for="item in kindData" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
		          	</el-select>
		        </el-form-item>
		        <el-form-item label="课程目标" prop="coursePurposeIds">
		          	<el-checkbox-group v-model="coursePurposeList" @change="ruleForm.coursePurposeIds=coursePurposeList.join(',')">
                        <el-checkbox :label="item.id" v-for="item in purposeData" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                    <el-input v-model="ruleForm.coursePurposeIds" type="hidden"></el-input> 
		        </el-form-item>

	        	<el-form-item label="课程时间" prop="beginTime">
	          		<el-date-picker v-model="ruleForm.beginTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width: 80%;" :disabled="is_director"></el-date-picker>
	        	</el-form-item>
	        	<el-form-item label="课程时长(分钟)" prop="durationId"> 
                    <el-radio-group v-model="ruleForm.durationId">
                        <el-radio :label="item.id" :key="item.id" v-for="item in courseTimeData">{{item.duration}}分钟</el-radio>
                    </el-radio-group>
	        	</el-form-item>

	        	<!-- <el-form-item label="可见度">
				    <el-checkbox-group v-model="ruleForm.visibility">
				      <el-checkbox label="指定用户可见" name="visibility"></el-checkbox>
				    </el-checkbox-group>
				</el-form-item> -->
                
	        	<!-- 封面图片 -->
	        	<el-form-item label="直播背景图片" prop="liveBackgroundUrl">
                    <el-input v-model="ruleForm.liveBackgroundUrl" placeholder style="width:40%"></el-input>
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(1)">
                        <el-image style="width: 150px; height: 150px" :src="ruleForm.liveBackgroundUrl" fit="fill" v-if="ruleForm.liveBackgroundUrl"></el-image>
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请选择图片</div>
                    </div>
                    <p style="font-sise:12px;color:red;">图片规格：650x348</p>
		        </el-form-item>
                <!-- 封面图片 -->
	        	<el-form-item label="直播封面图片" prop="liveCoverUrl">
                    <el-input v-model="ruleForm.liveCoverUrl" placeholder style="width:40%"></el-input>
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(2)">
                        <el-image style="width: 150px; height: 150px" :src="ruleForm.liveCoverUrl" fit="fill" v-if="ruleForm.liveCoverUrl"></el-image>
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请选择图片</div>
                    </div>
                    <p style="font-sise:12px;color:red;">图片规格：304x348</p>
		        </el-form-item>
                <!-- 封面图片'-->
	        	<el-form-item label="点播封面图片" prop="introPic">
                    <el-input v-model="ruleForm.introPic" placeholder style="width:40%"></el-input>
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(3)">
                        <el-image style="width: 150px; height: 150px" :src="ruleForm.introPic" fit="fill" v-if="ruleForm.introPic"></el-image>
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请选择图片</div>
                    </div>
                    <p style="font-sise:12px;color:red;">图片规格：650x348</p>
		        </el-form-item>
                <!-- 课程详情页视频-->
                <el-form-item label="课程详情页视频" prop="teachingVideo"> 
                    <el-input v-model="ruleForm.teachingVideo" placeholder style="width:40%"></el-input>
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(4)">
                        <video style="width: 150px; height: 150px" :src="ruleForm.teachingVideo" controls v-if="ruleForm.teachingVideo">您的浏览器不支持视频播放</video> 
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请选择视频</div>
                    </div>
		        </el-form-item>
                <!-- 课程详情页视频封面-->
                <el-form-item label="课程详情页视频封面" prop="teachingPic">
                    <el-input v-model="ruleForm.teachingPic" placeholder style="width:40%"></el-input>
                    <div class="zhenjian-id-box" style="border: 1px dashed #eee" @click="openImgMode(5)">
                        <el-image style="width: 150px; height: 150px" :src="ruleForm.teachingPic" fit="fill" v-if="ruleForm.teachingPic"></el-image>
                        <div class="zhenjian-id-box zhenjian-flex" v-else>请选择图片</div> 
                    </div>
                    <p style="font-sise:12px;color:red;">图片规格：750x420</p>
		        </el-form-item>
                
	        	<el-form-item label="课程介绍" prop="introText">
	          		<el-input type="textarea" v-model="ruleForm.introText" style="width:80%" :rows="4" :disabled="is_director"></el-input>
	        	</el-form-item>
		        <!-- <el-form-item label="课程介绍_en" prop="introTextEn">
		          	<el-input type="textarea" v-model="ruleForm.introTextEn" style="width:80%" :rows="4" :disabled="is_director"></el-input>
		        </el-form-item> -->
		        <!-- <el-form-item label="直播地址(高清)" prop="liveVideo" class="">
		          	<label style="width: 80%;">{{ruleForm.liveVideo}}</label>
		        </el-form-item> -->
                
	        	<el-form-item label="源视频(高清)地址" class="video-upload">
	          		<el-input v-model="ruleForm.originalVideoHigh" placeholder style="width: 80%;"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFiles" accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb" :show-file-list="false" :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess" :on-progress="uploadVideoProcess">
	            		<video v-if="ruleForm.originalVideoHigh !='' && videoFlag == false" :src="ruleForm.originalVideoHigh" width="350" height="180" controls="controls">您的浏览器不支持视频播放</video>
			            <i v-else-if="ruleForm.originalVideoHigh =='' && videoFlag == false" class="el-icon-plus avatar-uploader-icon"></i>
			            <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:31px"></el-progress>
	          		</el-upload>
	        	</el-form-item>
	        	<el-form-item label="源视频(标清)地址" class="video-upload">
		          	<el-input v-model="ruleForm.originalVideoStandard" placeholder style="width: 80%;"></el-input>
		          	<el-upload class="avatar-uploader" :action="tmpFiles" accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb" :show-file-list="false" :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess2" :on-progress="uploadVideoProcess2">
		            	<video v-if="ruleForm.originalVideoStandard !='' && videoFlag2 == false" :src="ruleForm.originalVideoStandard" width="350" height="180" controls="controls">您的浏览器不支持视频播放</video>
		            	<i v-else-if="ruleForm.originalVideoStandard =='' && videoFlag2 == false" class="el-icon-plus avatar-uploader-icon"></i>
		            	<el-progress v-if="videoFlag2 == true" type="circle" :percentage="videoUploadPercent2" style="margin-top:30px"></el-progress>
		          	</el-upload>
		        </el-form-item>
                <el-form-item label="源视频(低清)地址" class="video-upload">
	                <el-input v-model="ruleForm.originalVideoLow" placeholder></el-input>
	                <el-upload class="avatar-uploader" :action="tmpFiles" accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb" :show-file-list="false" :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess3" :on-progress="uploadVideoProcess3">
	                  <video v-if="ruleForm.originalVideoLow !='' && videoFlag3 == false" :src="ruleForm.originalVideoLow" width="350" height="180" controls="controls">您的浏览器不支持视频播放</video>
	                  <i v-else-if="ruleForm.originalVideoLow =='' && videoFlag3 == false" class="el-icon-plus avatar-uploader-icon"></i>
	                  <el-progress v-if="videoFlag3 == true" type="circle" :percentage="videoUploadPercent3" style="margin-top:30px"></el-progress>
	                </el-upload>
	            </el-form-item>
		        <el-form-item label prop="id" v-show="isShow">
		          	<el-input v-model="ruleForm.id" placeholder></el-input>
		        </el-form-item>
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSave()">确 定</el-button>	
	      	</span>
	    </el-dialog>
	    <!-- 阶段弹框 -->
	    <el-dialog title="课程阶段" :visible.sync="dialogVisible3" width="90%" top="40px" :before-close="handleClose3" class='stagecon'>
	      	<div class="stagetit">
	        	<span>课程名称：{{stageData.name}}</span>
		        <span>课程时长：{{globalMetod('formatTimes',stageData.beginTime,stageData.endTime)}}分钟</span>
		        <span>课程类型：{{stageData.courseKindName}}</span>
		        <span v-if="stageData.courseIntensityName">课程强度：{{stageData.courseIntensityName}}</span>
		        <!-- <span>训练模式: 训练模式</span> -->
	      	</div>
            <!-- <div style="padding:4px;">
                <el-tabs v-model="activeClass" @tab-click="handleClassClick">
                    <el-tab-pane label="课程阶段录入" name="1"></el-tab-pane>
                    <el-tab-pane label="课程阶段心率图" name="2"></el-tab-pane>
                    <el-tab-pane label="课程阶段功率图" name="3"></el-tab-pane>
                </el-tabs>
            </div> -->
	      	<div>
                <div style="padding:10px;">课程阶段录入</div>
                <div style="padding:10px;">
				    <el-button type="primary" @click="addLine" plain>添加行</el-button>
                </div>
                <div class="drag-table">
                    <table v-if="courseSportsKindId == 1">
                        <tr class="header">
                                <td style="width:4.32%">拖动</td>
                                <td style="width:8.32%">阶段</td>
                                <td style="width:8.32%">技巧</td>
                                <td style="width:8.32%">分钟</td>
                                <td style="width:8.32%">秒数</td>
                                <td style="width:8.32%">最小踏频</td>
                                <td style="width:8.32%">最大踏频</td>
                                <td style="width:8.32%">最小阻力</td>
                                <td style="width:8.32%">最大阻力</td>
                                <td style="width:8.32%">心率%</td>
                                <td style="width:12.32%">备注</td>
                                <td style="width:8.32%">操作</td>
                            </tr>
                    </table>
                    <table  v-if="courseSportsKindId == 1">
                        <vuedraggable v-model="coursePhaseData" animation="500"  force-fallback="true"  handle=".move"   @update="datadragEnd">
                            <tr v-for="(item,index) in coursePhaseData" :key="item.phase">
                                    <td style="width:4.32%" class="move">
                                        <i class="el-icon-sort" style="font-size:30px;color:#f56c6c;margin-top:6px;"></i>
                                    </td>
                                    <td style="width:8.32%">{{item.phase}}</td>
                                    <td style="width:8.32%">
                                        <el-select v-model="item.name" placeholder="请选择技巧">
                                            <el-option :label="val.phaseName" :value="val.phaseName" v-for="val in skills" :key="val.value"></el-option>
                                        </el-select>
                                    </td>
                                    <td style="width:8.32%">
                                        <el-input v-model="item.minutes" @change="handleClassClick1"></el-input>
                                    </td>
                                    <td style="width:8.32%">
                                        <el-input v-model="item.seconds" @change="handleClassClick1"></el-input>
                                    </td>
                                    <td style="width:8.32%">
                                        <el-input v-model="item.minRpm"></el-input>
                                    </td>
                                    <td style="width:8.32%">
                                        <el-input v-model="item.maxRpm"></el-input>
                                    </td>
                                    <td style="width:8.32%">
                                        <el-input v-model="item.minResist"></el-input>
                                    </td>
                                    <td style="width:8.32%">
                                        <el-input v-model="item.maxResist"></el-input>
                                    </td>
                                    <td style="width:8.32%">
                                        <el-input v-model="item.heartRate" @change="handleClassClick1"></el-input>
                                    </td>
                                    <td style="width:12.32%">
                                        <el-input placeholder="请输入内容" v-model="item.teleprompter"></el-input>
                                    </td>
                                    <td  style="width:8.32%">
                                        <p style="display:flex;padding: 0 10px;justify-content: space-around;">
                                            <el-popconfirm title="请选择复制方式" confirm-button-text="向上复制" cancel-button-text="向下复制" @cancel="stageCopy(item,index,2)" @confirm="stageCopy(item,index,1)">
                                                <el-button
                                                    slot="reference"
                                                    type="text"
                                                    size="small"
                                                    icon="el-icon-update">复制</el-button>
                                            </el-popconfirm>
                                            <el-popconfirm title="确定删除吗？" @confirm="delLine(index)">
                                                <el-button v-has="'course_type_delete'"
                                                    slot="reference"
                                                    type="text"
                                                    size="small"
                                                    style="color:red;"
                                                    icon="el-icon-delete">删除</el-button>
                                            </el-popconfirm>
                                        </p>
                                    </td>
                                </tr>
                        </vuedraggable>
                    </table>
                    <table v-if="courseSportsKindId == 2">
                        <tr class="header">
                            <td style="width:4.13%">拖动</td>
                            <td style="width:7.13%">阶段</td>
                            <td style="width:7.13%">技巧</td>
                            <td style="width:7.13%">分钟</td>
                            <td style="width:7.13%">秒数</td>
                            <td style="width:7.13%">最小步频</td>
                            <td style="width:7.13%">最大步频</td>
                            <td style="width:7.13%">最小速度</td>
                            <td style="width:7.13%">最大速度</td>
                            <td style="width:7.13%">最小坡度</td>
                            <td style="width:7.13%">最大坡度</td>
                            <td style="width:7.13%">心率%</td>
                            <td style="width:9.13%">备注</td>
                            <td style="width:8.13%">操作</td>
                        </tr>
                    </table>
                    <table  v-if="courseSportsKindId == 2">
                        <vuedraggable v-model="coursePhaseData" animation="500"  force-fallback="true"  handle=".move"  @update="datadragEnd">
                            <tr v-for="(item,index) in coursePhaseData" :key="item.phase">
                                <td style="width:4.13%" class="move" >
                                    <i class="el-icon-sort" style="font-size:30px;color:#f56c6c;margin-top:6px;"></i>
                                </td>
                                <td style="width:7.13%">{{item.phase}} </td>
                                <td style="width:7.13%">
                                    <el-select v-model="item.name" placeholder="请选择技巧">
                                        <el-option :label="val.phaseName" :value="val.phaseName" v-for="val in skills" :key="val.value"></el-option>
                                    </el-select>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.minutes" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.seconds" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.minCadence"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.maxCadence"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.minSpeed"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.maxSpeed"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.minIncline"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.maxIncline"></el-input>
                                </td>
                                <td style="width:7.13%">
                                    <el-input v-model="item.heartRate" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:9.13%">
                                    <el-input  placeholder="请输入内容" v-model="item.teleprompter"></el-input>
                                </td>
                                <td style="width:8.13%">
                                    <p style="display:flex;padding: 0 10px;justify-content: space-around;">
                                        <el-popconfirm title="请选择复制方式" confirm-button-text="向上复制" cancel-button-text="向下复制" @cancel="stageCopy(item,index,2)" @confirm="stageCopy(item,index,1)">
                                            <el-button
                                                slot="reference"
                                                type="text"
                                                size="small"
                                                icon="el-icon-update">复制</el-button>
                                        </el-popconfirm>
                                        <el-popconfirm title="确定删除吗？" @confirm="delLine(index)">
                                            <el-button v-has="'course_type_delete'"
                                                slot="reference"
                                                type="text"
                                                size="small"
                                                style="color:red;"
                                                icon="el-icon-delete">删除</el-button>
                                        </el-popconfirm>
                                    </p>
                                </td>
                            </tr>
                        </vuedraggable>
                    </table>
                    <table v-if="courseSportsKindId == 3">
                        <tr class="header">
                            <td style="width:4.32%">拖动</td>
                            <td style="width:8.32%">阶段</td>
                            <td style="width:8.32%">技巧</td>
                            <td style="width:8.32%">分钟</td>
                            <td style="width:8.32%">秒数</td>
                            <td style="width:8.32%">最小转速</td>
                            <td style="width:8.32%">最大转速</td>
                            <td style="width:8.32%">最小阻力</td>
                            <td style="width:8.32%">最大阻力</td>
                            <td style="width:8.32%">心率%</td>
                            <td style="width:12.32%">备注</td>
                            <td style="width:8.32%">操作</td>
                        </tr>
                    </table>
                    <table  v-if="courseSportsKindId == 3">
                        <vuedraggable v-model="coursePhaseData" animation="500"  force-fallback="true"  handle=".move"   @update="datadragEnd">
                            <tr v-for="(item,index) in coursePhaseData" :key="item.phase">
                                <td style="width:4.32%"  class="move">
                                    <i class="el-icon-sort" style="font-size:30px;color:#f56c6c;margin-top:6px;"></i>
                                </td>
                                <td style="width:8.32%">{{item.phase}}</td>
                                <td style="width:8.32%">
                                    <el-select v-model="item.name" placeholder="请选择技巧">
                                        <el-option :label="val.phaseName" :value="val.phaseName" v-for="val in skills" :key="val.value"></el-option>
                                    </el-select>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.minutes" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.seconds" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.minRpm"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.maxRpm"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.minResist"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.maxResist"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.heartRate" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:12.32%">
                                    <el-input placeholder="请输入内容" v-model="item.teleprompter"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <p style="display:flex;padding: 0 10px;justify-content: space-around;">
                                        <el-popconfirm title="请选择复制方式" confirm-button-text="向上复制" cancel-button-text="向下复制" @cancel="stageCopy(item,index,2)" @confirm="stageCopy(item,index,1)">
                                            <el-button
                                                slot="reference"
                                                type="text"
                                                size="small"
                                                icon="el-icon-update">复制</el-button>
                                        </el-popconfirm>
                                        <el-popconfirm title="确定删除吗？" @confirm="delLine(index)">
                                            <el-button v-has="'course_type_delete'"
                                                slot="reference"
                                                type="text"
                                                size="small"
                                                style="color:red;"
                                                icon="el-icon-delete">删除</el-button>
                                        </el-popconfirm>
                                    </p>
                                </td>
                            </tr>
                        </vuedraggable>
                    </table>
                    <table v-if="courseSportsKindId == 4">
                        <tr class="header">
                                <td style="width:4.32%">拖动</td>
                                <td style="width:8.32%">阶段</td>
                                <td style="width:8.32%">技巧</td>
                                <td style="width:8.32%">分钟</td>
                                <td style="width:8.32%">秒数</td>
                                <td style="width:8.32%">最小转速</td>
                                <td style="width:8.32%">最大转速</td>
                                <td style="width:8.32%">最小阻力</td>
                                <td style="width:8.32%">最大阻力</td>
                                <td style="width:8.32%">心率%</td>
                                <td style="width:12.32%">备注</td>
                                <td style="width:8.32%">操作</td>
                            </tr>
                    </table>
                    <table  v-if="courseSportsKindId == 4">
                        <vuedraggable v-model="coursePhaseData" animation="500"  force-fallback="true"  handle=".move"   @update="datadragEnd">      
                            <tr v-for="(item,index) in coursePhaseData" :key="item.phase">
                                <td style="width:4.32%" class="move">
                                    <i class="el-icon-sort" style="font-size:30px;color:#f56c6c;margin-top:6px;"></i>
                                </td>
                                <td style="width:8.32%">{{item.phase}}</td>
                                <td style="width:8.32%">
                                    <el-select v-model="item.name" placeholder="请选择技巧">
                                        <el-option :label="val.phaseName" :value="val.phaseName" v-for="val in skills" :key="val.value"></el-option>
                                    </el-select>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.minutes" @change="handleClassClick1"></el-input>
                                </td >
                                <td style="width:8.32%">
                                    <el-input v-model="item.seconds" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.minRpm"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.maxRpm"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.minResist"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.maxResist"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <el-input v-model="item.heartRate" @change="handleClassClick1"></el-input>
                                </td>
                                <td style="width:12.32%">
                                    <el-input placeholder="请输入内容" v-model="item.teleprompter"></el-input>
                                </td>
                                <td style="width:8.32%">
                                    <p style="display:flex;padding: 0 10px;justify-content: space-around;">
                                        <el-popconfirm title="请选择复制方式" confirm-button-text="向上复制" cancel-button-text="向下复制" @cancel="stageCopy(item,index,2)" @confirm="stageCopy(item,index,1)">
                                            <el-button
                                                slot="reference"
                                                type="text"
                                                size="small"
                                                icon="el-icon-update">复制</el-button>
                                        </el-popconfirm>
                                        <el-popconfirm title="确定删除吗？" @confirm="delLine(index)">
                                            <el-button v-has="'course_type_delete'"
                                                slot="reference"
                                                type="text"
                                                size="small"
                                                style="color:red;"
                                                icon="el-icon-delete">删除</el-button>
                                        </el-popconfirm>
                                    </p>
                                </td>
                            </tr>
                        </vuedraggable>
                    </table>
                    <table v-if="courseSportsKindId > 4">
                        <tr class="header">
                            <td style="width:10%">拖动</td>
                            <td style="width:12.5%">阶段</td>
                            <td style="width:12.5%">技巧</td>
                            <td style="width:12.5%">分钟</td>
                            <td style="width:12.5%">秒数</td>
                            <td style="width:12.5%">心率%</td>
                            <td style="width:15%">备注</td>
                            <td style="width:12.5%">操作</td>
                        </tr>
                    </table>
                    <table v-if="courseSportsKindId>4">
                        <vuedraggable v-model="coursePhaseData" animation="500"  force-fallback="true"  handle=".move"  @update="datadragEnd" >
                            <tr v-for="(item,index) in coursePhaseData" :key="item.phase">
                                    <td style="width:10%" class="move">
                                        <i class="el-icon-sort" style="font-size:30px;color:#f56c6c;margin-top:6px;"></i>
                                    </td>
                                    <td style="width:12.5%">{{item.phase}}</td>
                                    <td style="width:12.5%">
                                        <el-input v-model="item.name"></el-input>
                                    </td>
                                    <td style="width:12.5%">
                                        <el-input v-model="item.minutes"></el-input>
                                    </td>
                                    <td style="width:12.5%">
                                        <el-input v-model="item.seconds"></el-input>
                                    </td>
                                    <td style="width:12.5%">
                                    <el-input v-model="item.heartRate"></el-input>
                                </td>
                                    <td style="width:15%">
                                        <el-input placeholder="请输入内容" v-model="item.teleprompter"></el-input>
                                    </td>
                                    <td style="width:12.5%">
                                        <p style="display:flex;padding: 0 10px;justify-content: space-around;">
                                            <el-popconfirm title="请选择复制方式" confirm-button-text="向上复制" cancel-button-text="向下复制" @cancel="stageCopy(item,index,2)" @confirm="stageCopy(item,index,1)">
                                                <el-button
                                                    slot="reference"
                                                    type="text"
                                                    size="small"
                                                    icon="el-icon-update">复制</el-button>
                                            </el-popconfirm>
                                            <el-popconfirm title="确定删除吗？" @confirm="delLine(index)">
                                                <el-button v-has="'course_type_delete'"
                                                    slot="reference"
                                                    type="text"
                                                    size="small"
                                                    style="color:red;"
                                                    icon="el-icon-delete">删除</el-button>
                                            </el-popconfirm>
                                        </p>
                                    </td>
                                </tr>
                        </vuedraggable>
                    </table>
                </div>
            </div>
	      	<div>
                 <div style="padding:10px;">课程阶段心率图</div>
                <div class="eachart-box">
                    <div class="eachart-box-bar">
                        <div class="eachart-box-progress" v-for="(item,index) in xlLineData" :key="index" :style="{height:(100/xlLineData.length)+'%'}">
                            <div class="eachart-box-progress-text">{{item.name}}</div>
                            <div class="eachart-box-progress-line" :style="{backgroundColor:item.color}"></div>
                        </div>
                    </div>
                    <div style="height:500px;" ref="xlEachartBox"></div> 
                </div>
            </div>
	      	<div>
                <div style="padding:10px;">课程阶段功率图</div>
                <div class="eachart-box">
                    <div class="eachart-box-bar">
                        <div class="eachart-box-progress" v-for="(item,index) in glLineData" :key="index" :style="{height:(100/glLineData.length)+'%'}">
                            <div class="eachart-box-progress-text">{{item.name}}</div>
                            <div class="eachart-box-progress-line" :style="{backgroundColor:item.color}"></div>
                        </div>
                    </div>
                    <div style="height:500px;" ref="glEachartBox"></div>
                </div>
            </div>
	      	<div style="padding:20px 0 0">总时长：{{totalTime}}秒</div>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible3 = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
	      	</span>
	    </el-dialog>
	    <!-- 重新编排弹框 -->
	    <el-dialog title="课程重新编排" :visible.sync="dialogVisible4" width="25%" :before-close="handleClose4">
	      	<el-date-picker
		      	v-model="coursetimeVal"
		      	type="datetimerange"
		      	range-separator="至"
		      	start-placeholder="课程开始时间"
		      	end-placeholder="课程结束时间"
		      	value-format="timestamp" style="width:100%">
		    </el-date-picker >
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible4 = false">取 消</el-button>
		        <el-button type="primary" @click="courseEncoreSubmit()">确 定</el-button>
	      	</span>
	    </el-dialog>
        <gallery-model :active="galleryActive" :choice-img="choiceImg" :dialog.sync="galleryModelShow" ></gallery-model>
  	</div>
</template>  
<script>
import GalleryModel from '@/components/GalleryModel';
import * as echarts from 'echarts';
import vuedraggable from 'vuedraggable';
export default {
    components: {GalleryModel,vuedraggable},
    mounted() {
        this.userId = localStorage.getItem('userId');
        //this.init()
        this.page();
        this.sportsKind();
        this.selCoachesData();
        this.purposeDataMethod();
        if (eval(localStorage.getItem('userMenuButton')).indexOf('course_list_stick') != -1) {
            this.hasshow = true;
            return false;
        }
    },
    data() {
        return {
            galleryActive:'1',
            activeClass:'1',
            galleryModelShow:false,
            activeName:'-1',
            cur: -1,
            userId: '',
            checkCoachesList:[],
            
            courseTagVosList:[],
            purposeData:[],
            paramcoach: {
                pageNum: 1,
                limit: 10
            }, //选择教练参数配置
            headers: {
                'yj-admin-token': localStorage.getItem("token")
            },
            tmpFiles: process.env.API_ROOT + '/tmpFiles',
            selData: [], //选择运动种类
            tableData2: [], //选择门店
            tableData: [], //初始化表格
            pageNum: 1,
            limit: 10,
            totalPage: 10,
            coachesData: [], //教练列表
            coursePurposeList:[],
            pageNum2: 1,
            courseSportsKindId:null,
            limit2: 5,
            totalPage2: 10,
            kindData: [], //课程类型列表
            courseTimeData: [], //课程时长
            freetimeVal:[],
            currentRow: '',
            ruleForm: {
                backcolor: 2,//背景色 背景色 1：浅色 2：深色 
                beginTime: '',
                introVideoUrl:'',
                coachIds:'',
                courseTagVos: [],
                durationId:1,
                introPic: '',
                introText: '',
                sportsKindId: '',
                liveBackgroundUrl:'',
                coursePurposeIds:'',
                liveCoverUrl:'',
                id: '',
                kindId: '',
                originalVideoHigh: '',//高清视频
                originalVideoStandard: '',//标清视频
                originalVideoLow: '',//低清视频
                liveChargeStatus:1,
                chargeStatus:1,
                freeStartTime:'',
                freeEndTime:'',
                teachingVideo:'',
                courseIntensityId:'',
                teachingPic:''
            },
            videoFlag: false, //刚开始的时候显示为flase
            videoUploadPercent: '0%', //进度条刚开始的时候为0%
            Video: '',
            videoFlag2: false,
            videoUploadPercent2: '0%',
            videoFlag3: false,
            videoUploadPercent3: '0%', 
            ruleForms: {
                sportsKindId: [{ required: true, message: '请选择运动类型'}],
                name: [{ required: true, message: '请输入课程名字'}],
                nameEn: [{ required: true, message: '请输入课程名字_en' }],
                durationId: [{ required: true, message: '请选择课程时长'}],
                coachIds: [{ required: true, message: '请选择教练'}],
                beginTime: [{ required: true, message: '请选择课程时间', trigger: 'change' }],
                coursePurposeIds: [{ required: true, message: '请选择课程目标',}],
                freeStartTime: [{ required: true, message: '请选择课程目标',}],
                courseIntensityId: [{ required: true, message: '请选择课程强度',}],

                // courseIntensityId: [  teachingPic  
                //     { required: true, message: '请选择课程强度', trigger: 'change' }
                // ]
            },
            dialogVisible: false,
            isShow: false,
            dialogVisible2: false,
            dialogVisible3: false,
            //课程阶段列表
            coursePhaseData: [],
            sportsKindId: 0,
            kindIdisShow: false, //课程类型
            stageData: '', //阶段数据
            intensityData: [], // 课程强度
            nicknameData: [],
            courseName: '',
            fuzzyQueryShow: false,
            coachId: '', //教练ID
            timeVal: '',
            dialogVisible4: false,
            coursetimeVal: '', //课程编排时间
            returnCourse: '',
            is_director: false, //是否是导演角色
            hasshow: false,
            courseTagVosData: [], //课程标签
            resultArr: [],
            sportsKindIdphase: 0,
            courseEditId:'',
            skills: [],
            powerIntervalList: [
                //功率区间
                { id: 1, label: '1:0-55' },
                { id: 2, label: '2:56-75' },
                { id: 3, label: '3:76-90' },
                { id: 4, label: '4:91-105' },
                { id: 5, label: '5:106-120' },
                { id: 6, label: '6:121-150' },
                { id: 7, label: '7:150+' }
            ],
            xlLineData:[
                {max:100,min:90,color:'#DC0313',name:'最大摄氧量'},
                {max:89,min:80,color:'#FED656',name:'心肺提升'},
                {max:79,min:70,color:'#95D84D',name:'高效燃脂'},
                {max:69,min:60,color:'#54C3F3',name:'耐力燃脂'},
                {max:59,min:1,color:'#B7BABC',name:'恢复放松'}, 
            ],
            glLineData: [
                { max: 200, min: 151, color: '#9C45B7', name: '爆发力'},
                { max: 150, min: 121, color: '#DD2831', name: '无氧能力'},
                { max: 120, min: 106, color: '#FD605E', name: '最大摄氧量'},
                { max: 105, min: 90, color: '#F2D55E', name: '心肺提升'},
                { max: 90, min: 76, color: '#97DC57', name: '高效燃脂'},
                { max: 75, min: 56, color: '#40DAF6', name: '耐力燃脂'},
                { max: 55, min: 1, color: '#E4E4E4', name: '恢复放松'},
            ],
            stageSection:{ 
                // 跑步
                run:{
                    name:{value:'',reg:/^.+$/,msg:'技巧错误'},//技巧
                    minutes: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'分钟错误'},//分
                    seconds: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'秒错误'},//秒
                    minCadence:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小步频错误'},//最小步频
                    maxCadence:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大步频错误'},//最大步频：
                    minSpeed:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小速度错误'},//最小速度：
                    maxSpeed:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大速度错误'},//最大速度：
                    minIncline:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小坡度错误'},//最小坡度：
                    maxIncline:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大坡度错误'},//最大坡度：
                    heartRate:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'心率错误'},//心率 
                    teleprompter:{value:0,reg:false},//备注
                },
                // 单车
                bicycle:{
                    name:{value:'',reg:/^.+$/,msg:'技巧错误'},//技巧
                    minutes: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'分钟错误'},//分
                    seconds: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'秒错误'},//秒   
                    minRpm:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小踏频错误'},//最小踏频
                    maxRpm:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大踏频错误'},//最大踏频
                    minResist:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小阻力错误'},//最小阻力
                    maxResist:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大阻力错误'},//最大阻力
                    heartRate:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'心率错误'},//心率
                    teleprompter:{value:0,reg:false},//备注
                },
                //椭圆机
                ellipticalMachine:{
                    name:{value:'',reg:/^.+$/,msg:'技巧错误'},//技巧
                    minutes: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'分钟错误'},//分
                    seconds: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'秒错误'},//秒   
                    minRpm:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小浆频错误'},//最小浆频
                    maxRpm:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大桨频错误'},//最大浆频
                    minResist:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小阻力错误'},//最小阻力
                    maxResist:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大阻力错误'},//最大阻力
                    heartRate:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'心率错误'},//心率
                    teleprompter:{value:0,reg:false},//备注
                },
                //划船机
                rowingMachine:{
                    name:{value:'',reg:/^.+$/,msg:'技巧错误'},//技巧
                    nameType:{value:'select',reg:false},
                    minutes: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'分钟错误'},//分
                    seconds: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'秒错误'},//秒   
                    minRpm:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小转数错误'},//最小转数
                    maxRpm:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大转数错误'},//最大转数
                    minResist:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最小阻力错误'},//最小阻力
                    maxResist:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'最大阻力错误'},//最大阻力
                    heartRate:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'心率错误'},//心率
                    teleprompter:{value:0,reg:false},//备注
                },
                other:{
                    name:{value:'',reg:/^.+$/,msg:'技巧错误'},//技巧
                    minutes: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'分钟错误'},//分
                    seconds: {value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'秒错误'},//秒  
                    heartRate:{value:0,reg:/^[0-9]*[0-9][0-9]*$/,msg:'心率错误'},//心率
                }
            }
        };
    },
    computed: {
        //计算时长
        totalTime: function() {
            let endTotal = 0;
            let that = this;
            for (let i = 0; i < that.coursePhaseData.length; i++) {
                if (that.coursePhaseData[i].seconds) {
                    endTotal += parseInt(that.coursePhaseData[i].seconds);
                }
            }
            let startTotal = 0;
            for (let i = 0; i < that.coursePhaseData.length; i++) {
                if (that.coursePhaseData[i].minutes) {
                    startTotal += parseInt(that.coursePhaseData[i].minutes);
                }
            }
            var totalTime2 = parseInt(startTotal * 60) + parseInt(endTotal);
            return that.global.formatSecond(totalTime2);
        },
        coachesChoice:function(){
            let arr=[];
            this.coachesData.forEach(item=>{
                this.checkCoachesList.forEach(val=>{
                    if(item.id == val){
                        arr.push(item)
                    }
                })
            })
            return arr;
        },
    },
    watch:{
        'ruleForm.kindId':function(val){
            let cIndex=this.$_.findIndex(this.kindData, item => item.id === val);
            if(cIndex>=0 && !this.ruleForm.id){
                this.ruleForm.introText=this.kindData[cIndex].introduction;
                this.ruleForm.teachingVideo=this.kindData[cIndex].introVideoUrl;
            }
        }
    },
    filters: {
        formatDate: function(value) {
            let date = new Date(value);
            let h = date.getHours();
            h = h < 10 ? '0' + h : h;
            let m = date.getMinutes();
            m = m < 10 ? '0' + m : m;
            let s = date.getSeconds();
            s = s < 10 ? '0' + s : s;
            return h + '时' + m + '分' + s;
        }
    },
    methods: {
        datadragEnd(e){
            this.coursePhaseData.forEach((item, index) => {
                item.phase=index+1;
            });
        },
        tableRowClassName({row, rowIndex}) {
            let current=this.$moment().valueOf(),beginTime=this.$moment(row.beginTime).valueOf();
            if(beginTime>current){
                return 'warning-row';
            }
            return '';
        },
        handleClassClick(){
            if(this.coursePhaseData.length>0 && this.activeClass>1){
                let xData=this.coursePhaseData.map(item=>item.minutes+':'+item.seconds),
                yData=[],element='',title='',infos='';
                if(this.activeClass == 2){
                    echarts.init(this.$refs['xlEachartBox']).dispose();
                    yData=this.coursePhaseData.map(item=>(item.heartRate>0?Number(item.heartRate):0))
                    infos=this.xlLineData;
                    title='心率';
                    element=this.$refs['xlEachartBox']; 
                }else if(this.activeClass == 3){
                    echarts.init(this.$refs['glEachartBox']).dispose();
                    yData=this.coursePhaseData.map(item=>(item.power>0?Number(item.power):0))
                    infos=this.glLineData;
                    title='功率';
                    element=this.$refs['glEachartBox'];
                }
                setTimeout(()=>this.showEacharts(xData,yData,element,infos,title),10)
            }
        },
        handleClassClick1(){
            if(this.coursePhaseData.length>0){
                let xData=this.coursePhaseData.map(item=>item.minutes+':'+item.seconds);
                let yData=this.coursePhaseData.map(item=>(item.heartRate>0?Number(item.heartRate):0))
                this.showEacharts(xData,yData,this.$refs['xlEachartBox'],this.xlLineData,'心率')
                let yData1=this.coursePhaseData.map(item=>(item.power>0?Number(item.power):0))
                this.showEacharts(xData,yData1,this.$refs['glEachartBox'],this.glLineData,'功率')
            }
        },
        updatesw(index, id, status) {
            if (!id) return this.$message.error("课程列表错误");
            const url = status == 3 ? "/course/open/" : "/course/close/";
            const loading = this.$loading({ text: "加载中..." });
            this.$put(url+id)
                .then((res) => {
                if (res.code == 0) {
                    this.$message.success("操作成功");
                    this.tableData[index].visibility = status == 3 ? 0 : 3;
                } else {
                    this.$message.error(JSON.stringify(res.message));
                }
                loading.close();
                })
                .catch((err) => {
                this.$message.error(JSON.stringify(err));
                loading.close();
                });
        },
        courseTagVosMethod(){
            let arr=[];
            this.courseTagVosData.forEach(item=>{
                this.courseTagVosList.forEach(val=>{
                    if(item.id == val){
                        arr.push({tagId:item.id,tagName:item.name})
                    }
                })
            })
            this.ruleForm.courseTagVos=arr;
        },
        coachesChoiceMethod(coachesId){
            for(let i=0;i<this.checkCoachesList.length;i++){
                if(this.checkCoachesList[i] == coachesId){
                    this.checkCoachesList.splice(i,1)
                }
            }
            this.ruleForm.coachIds=this.checkCoachesList.join(',')
        },
        globalMetod(method,query,query1){
            return this.global[method](query,query1)
        },
        openImgMode(flag){
            this.galleryModelShow=true;
            this.upLodTypes=flag;
            this.galleryActive=flag+''
        },
        choiceImg(e){
            if(this.upLodTypes == 1){
                this.ruleForm.liveBackgroundUrl=e.coverUrl;
            }else if(this.upLodTypes == 2){
                this.ruleForm.liveCoverUrl=e.coverUrl;
            }else if(this.upLodTypes == 3){
                this.ruleForm.introPic=e.coverUrl;
            }else if(this.upLodTypes == 4){
                this.ruleForm.teachingVideo=e.coverUrl;
            }else if(this.upLodTypes == 5){
                this.ruleForm.teachingPic=e.coverUrl;
            }
        },
        courseTagVos() {
            this.$get('/course/getCourseTagMapping').then(res => {
                if (res.code == 0) {
                    this.courseTagVosData = Array.isArray(res.data)?res.data:[];
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        //初始化表格数据
        page() {
            var params = this.calculate();
            this.$get('/course', params)
                .then(res => {
                    if (res.code == 0) {
                        this.tableData = res.data.list;
                        this.totalPage = res.data.total;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
        },
        calculate() {
            var dataFer = {
                pageNum: this.pageNum,
                limit: this.limit,
                userId: this.userId,
                sportsKindId: this.sportsKindId,
                courseName: this.courseName
            };
            if (this.coachId) {
                dataFer.coachId = this.coachId;
            }
            if (this.timeVal) {
                dataFer.beginTime = this.$moment(this.timeVal[0]).valueOf();
                dataFer.endTime = this.$moment(this.timeVal[1]).valueOf();
            }
            return dataFer;
        },
        init() {
            var params = {
                pageNum: this.pageNum,
                limit: this.limit,
                userId: this.userId,
                sportsKindId: this.sportsKindId
            };
            this.$get('/course', params).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.list;
                    this.totalPage = res.data.total;
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        search() {
            //模糊查询
            this.coachId = '';
            if (this.nickname) {
                var params = {
                    pageNum: 1,
                    limit: this.limit,
                    nickname: this.nickname
                };
                this.$get('/coaches/nickname', params).then(res => {
                    if (res.code == 0) {
                        this.nicknameData = res.data.list;
                        if (res.data.list.length > 0) {
                            this.fuzzyQueryShow = true;
                        }
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                });
            } else {
                this.nicknameData = [];
                this.fuzzyQueryShow = false;
            }
        },
        nicknameitem(id, name) {
            this.coachId = id;
            this.nickname = name;
            this.fuzzyQueryShow = false;
        },
        search_mine() {
            this.pageNum = 1;
            this.page();
        },
        topHide() {
            this.fuzzyQueryShow = false;
        },
        //当前页数
        handleCurrentChangePage(val) {
            this.pageNum = val;
            this.page();
        },
        //当前教练页数
        handleCurrentChangePage2(val) {
            this.paramcoach.pageNum = val;
            this.selCoachesData();
        },
        //弹框关闭按钮
        handleClose(done) {
             if (this.$refs.ruleForm) {
                this.$refs.ruleForm.resetFields();
                this.$refs.ruleForm.clearValidate();
            }
            for(let i in  this.ruleForm){
                this.ruleForm[i]='';
            }
            this.ruleForm.backcolor=2;
            this.ruleForm.courseTagVos=[];
            this.freetimeVal=[];
            this.ruleForm.durationId=1;
            this.ruleForm.liveChargeStatus=1;
            this.ruleForm.chargeStatus=1;
            done();
        },
        //
        handleClose2() {
            this.dialogVisible2 = false;
        },
        //
        handleClose3() {
            this.dialogVisible3 = false;
        },
        handleClose4() {
            this.dialogVisible4 = false;
        },
        //选择需要修改的权限
        handleCurrentChange(val) {
            if (val) {
                this.sportsKindIdphase = val.sportsKindId;
                this.currentRow = val.id;
                //this.sportsKindId = val.sportsKindId;
                this.returnCourse = val.returnCourse;
            }
        },
        //点击选择用户行
        handleCurrentChange2(val) {
            this.dialogVisible2 = false;
            if (val) {
                this.ruleForm.coachId = val.id;
                this.ruleForm.coachName = val.nickName;
            }
        },
        //点击选择教练
        selCoachesDialog() {
            if (this.is_director == false) {
                this.dialogVisible2 = true;
            } else {
                this.$message({
                    message: '此身份不可编辑',
                    type: 'warning'
                });
            }
        },

        //选择门店
        selectStores() {
            var params = {
                pageNum: 1,
                limit: 20
            };
            this.$get('/stores', params)
                .then(res => {
                    if (res.code == 0) {
                        this.tableData2 = res.data.list;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
        },
        rulestoresId(val) {
            //修改门店
            this.ruleForm.storesId = val;
        },
        rulescourseTagVosId(val) {
            //选择课程标签
            this.ruleForm.courseTagVos = val;
        },
        //选择教练 
        selCoachesData() {
            this.$get('/coaches', {pageNum:1,limit:1000})
                .then(res => {
                    if (res.code == 0) {
                        this.coachesData = Array.isArray(res.data.list)?res.data.list:[];
                    } else {
                        this.$message.error(res.message);
                        return false;
                    }
                })
        },
         purposeDataMethod() {
            this.$get('/course/purpose')
                .then(res => {
                    if (res.code == 0) {
                        this.purposeData = Array.isArray(res.data)?res.data:[];
                    } else {
                        this.$message.error(res.message);
                        return false;
                    }
                })
        },
        //选择运动种类
        sportsKind() {
            this.$get('/course/sportsKind', {})
                .then(res => {
                    if (res.code == 0) {
                        let list=Array.isArray(res.data)?res.data:[];
                        list.forEach(item=>item.id=Number(item.id))
                        this.selData = res.data;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
        },
        rulesportKindId(val) {
            //修改运动类型
            this.ruleForm.kindId = '';
            if (val >= 0) {
                this.selCourseKind('change');
            }
        },
        //选择课程类型
        selCourseKind(e) {
            this.$get('/course/courseKind', {
                sportsKindId: this.ruleForm.sportsKindId
            })
                .then(res => {
                    if (res.code == 0) {
                        this.kindData = res.data;
                        if (res.data.length) {
                            if (e == 'change') {
                                this.ruleForm.courseKindName = res.data[0].name;
                                this.ruleForm.kindId = res.data[0].id;
                            }
                            this.kindIdisShow = true;
                        } else {
                            this.kindIdisShow = false;
                        }
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
        },
        rulekindId(val) {
            this.ruleForm.kindId = val;
        },
        //课程时长
        courseTime() {
            this.$get('/course/courseDuration', {})
                .then(res => {
                    if (res.code == 0) {
                        this.courseTimeData = Array.isArray(res.data)?res.data:[];
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
        },
        //课程强度
        intensity() {
            this.$get('/course/queryCourseIntensity', {})
                .then(res => {
                    if (res.code == 0) {
                        this.intensityData = Array.isArray(res.data)?res.data:[];
                    } else {
                        this.$message.error(res.message);
                    }
                })
        },
        ruleIntensityId(val) {
            //修改课程强度
            this.ruleForm.courseIntensityId = val;
        },
        ruledurationId(val) {
            //修改课程时长
            this.ruleForm.durationId = val;
        },
        //添加
        add(row) {
            this.$refs.multipleTable.setCurrentRow(row);
            if (this.$refs.ruleForm != undefined) {
                this.$refs.ruleForm.resetFields();
                this.ruleForm = {
                    backcolor: 2,//背景色 背景色 1：浅色 2：深色
                    beginTime: '',
                    coachId:'',
                    courseTagVos: [],
                    durationId:1,
                    introPic: '',
                    introText: '',
                    sportsKindId: '',
                    liveBackgroundUrl:'',
                    coursePurposeIds:'',
                    liveCoverUrl:'',
                    introVideoUrl:'',
                    id: '',
                    kindId: '',
                    originalVideoHigh: '',//高清视频
                    originalVideoStandard: '',//标清视频
                    originalVideoLow: '',//低清视频
                };
                this.checkCoachesList=[];
                this.courseTagVosList=[];
                this.coursePurposeList=[];
            }
            this.dialogVisible = true;
            this.currentRow = '';
            this.sportsKind();
            // this.selectStores();
            this.selCoachesData();
            this.courseTime();
            this.intensity(); //课程强度
            this.courseTagVos(); //课程标签
            // this.selCourseKind();
        },
        onSubmit() {
            var istrue = true,msg='',addListJson=null,rowNum;
             if(this.courseSportsKindId == 1){//单车
                addListJson=this.stageSection.bicycle;
            }else if(this.courseSportsKindId == 2){ //跑步机
                addListJson=this.stageSection.run;
            }else if(this.courseSportsKindId == 3){ //椭圆机
                addListJson=this.stageSection.ellipticalMachine;
            }else if(this.courseSportsKindId == 4){ //划船机
                addListJson=this.stageSection.rowingMachine;
            }else{
                addListJson=this.stageSection.other;
            }
            this.coursePhaseData.map((item,index) => {
                let keys=Object.keys(item)
                for(let i in addListJson){
                    if (keys.includes(i) && addListJson[i].reg && !addListJson[i].reg.test(item[i])) {
                        istrue = false;
                        msg=addListJson[i].msg;
                        rowNum=index+1;
                        break;
                    }
                }
            });
            if(istrue === false) return this.$message.error(`第${rowNum}行${msg}`);
            if (istrue == true) {
                this.$post('/coursePhase/' + this.courseEditId, this.coursePhaseData)
                    .then(res => {
                        if (res.code == 0) {
                            this.$message.success('保存成功');
                            this.dialogVisible3 = false;
                            this.page()
                        } else {
                            this.$message.error(res.message);
                        }
                    })
            }
        },
        courseEncore(data) {
            this.courseEditId=data.id;
            if (data.returnCourse != 1) {
                this.dialogVisible4 = true;
            } else {
                return this.$message.error('此课程已被编排');
            }
        },
        courseEncoreSubmit() {
            if (this.coursetimeVal.length < 1)return this.$message.error('请选择课程重新编排时间');
            var dataFer = {
                id: this.courseEditId,
                beginTime: this.coursetimeVal[0].valueOf(),
                endTime: this.coursetimeVal[1].valueOf()
            };
            this.$post('/course/courseEncore', JSON.stringify(dataFer)).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: '编排成功',
                        type: 'success'
                    });
                    this.coursetimeVal = [];
                    this.dialogVisible4 = false;
                    this.page();
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        topnav() {
            let index=Number(this.activeName);
            this.sportsKindId=index === -1?0:(Array.isArray(this.selData) && this.selData.length>0?this.selData[index].id:0)
            this.pageNum = 1;
            this.cur = index;
            this.page();
        },
        edit(currentRowId) {
            this.sportsKind();
            this.selCoachesData();
            this.courseTime();
            this.intensity(); //课程强度
            this.courseTagVos(); //课程标签
            this.$get('/course/queryCourseDetailById/', { id: currentRowId })
                .then(res => {
                    console.log('res***********',res);
                    if (res.code == 0) {
                        res.data.beginTime=this.$_.isNumber(res.data.beginTime)?this.$moment(res.data.beginTime).format("YYYY-MM-DD HH:mm:ss"):'';
                        this.coursePurposeList=this.$_.isString(res.data.coursePurposeIds)?(Array.isArray(res.data.coursePurposeIds.split(','))?res.data.coursePurposeIds.split(','):[]):[];
                        this.coursePurposeList=this.coursePurposeList.map(item=>Number(item));
                        this.checkCoachesList=this.$_.isString(res.data.coachId)?(Array.isArray(res.data.coachId.split(','))?res.data.coachId.split(','):[]):[];
                        this.checkCoachesList=this.checkCoachesList.map(item=>Number(item));
                        this.courseTagVosList=Array.isArray(res.data.courseTagVos) && res.data.courseTagVos.length>0?res.data.courseTagVos.map(item=>item.id):[];
                        this.freetimeVal=res.data.freeStartTime && res.data.freeEndTime?[res.data.freeStartTime,res.data.freeEndTime]:[];
                        res.data.coachIds=res.data.coachId;
                        this.dialogVisible = true;
                        this.$nextTick(function() {
                            this.ruleForm = res.data;
                            if (res.data.sportsKindId >= 0) {
                                console.log('进来');
                                this.selCourseKind();
                            }
                        });
                    }
                })
                .catch(() => {});
        },
        del(currentRowId) {
            const loading = this.$loading({ text: "加载中..." });
          this.$delete('/course/delete/' + currentRowId)
                .then((res)=>{
                    if (res.code == 0) {
                        this.$message.success('删除成功');
                        this.init();
                        this.dialogVisible = false;
                    } else {
                        const msg=res.message?res.message:'操作失败';
                        this.$message.error(msg);
                    }
                    loading.close();
                }).catch(() => {
					loading.close();
				});
        },
        onSave() {
             this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    const method=this.ruleForm.id?this.$put:this.$post;
                    const url=this.ruleForm.id?'/course/' + this.ruleForm.id:'course'
                    this.loading = true;
                    this.ruleForm.freeStartTime=this.freetimeVal.length>1?this.freetimeVal[0].valueOf():'',
                    this.ruleForm.freeEndTime=this.freetimeVal.length>1?this.freetimeVal[1].valueOf():''
                    method(url, this.ruleForm)
                        .then(res => {
                            if (res.code == 0) {
                                this.$message.success('操作成功');
                                this.dialogVisible = false;
                                this.page();
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        common() {
            this.currentRow = '';
            this.cur = -1;
            this.coachId = '';
            this.nickname = '';
            this.timeVal = '';
            this.sportsKindId = 0;
            this.page();
        },
        uploadVideoProcess(event, file, fileList) {
            //视频上传的时候获取上传进度传给进度条
            this.videoFlag = true;
            this.videoUploadPercent = parseInt(file.percentage);
        },
        handleVideoSuccess(res, file) {
            //视频上传成功之后返回视频地址
            this.videoFlag = false;
            this.videoUploadPercent = 0;
            this.ruleForm.originalVideoHigh = res.data.url;
        },
        // 视频2
        beforeUploadVideo(file) {
            //视频上传之前判断他的大小
            const isLt10M = file.size / 1024 / 1024 < 2000;
            if (!isLt10M) {
                this.$message.error('上传视频大小不能超过2000MB哦!');
                return false;
            }
        },
        uploadVideoProcess2(event, file, fileList) {
            //视频上传的时候获取上传进度传给进度条
            this.videoFlag2 = true;
            this.videoUploadPercent2 = parseInt(file.percentage);
        },
        handleVideoSuccess2(res, file) {
            //视频上传成功之后返回视频地址
            this.videoFlag2 = false;
            this.videoUploadPercent2 = 0;
            this.ruleForm.originalVideoStandard = res.data.url;
        },
        uploadVideoProcess3(event, file, fileList) {
            //视频上传的时候获取上传进度传给进度条
            this.videoFlag3 = true;
            this.videoUploadPercent3 = parseInt(file.percentage);
        },
        handleVideoSuccess3(res, file) {
            //视频上传成功之后返回视频地址
            this.videoFlag3 = false;
            this.videoUploadPercent3 = 0;
            this.ruleForm.originalVideoLow = res.data.url;
        },
        //点击阶段
        stage(data) {
            this.courseEditId=data.id;
            this.courseSportsKindId=data.sportsKindId;
            this.coursePhase(data.id,data.sportsKindId);
            // if (this.sportsKindIdphase == 1) {
            //     this.skills = [
            //         { value: '热身' },
            //         { value: '坐姿平路' },
            //         { value: '站姿平路' },
            //         { value: '平路交替' },
            //         { value: '坐姿爬坡' },
            //         { value: '站姿爬坡' },
            //         { value: '爬坡交替' },
            //         { value: '放松' },
            //         { value: '拉伸' }
            //     ];
            // } else {
            //     this.skills = [
            //         { value: '热身' },
            //         { value: '速度2' },
            //         { value: '速度4' },
            //         { value: '速度5' },
            //         { value: '速度6' },
            //         { value: '速度7' },
            //         { value: '速度8' },
            //         { value: '速度9' },
            //         { value: '速度10' },
            //         { value: '速度11' },
            //         { value: '速度12' },
            //         { value: '放松拉伸' }
            //     ];
            // }
            this.$get('/coursePhase/name/'+data.sportsKindId).then(res => {
                if (res.code == 0) {
                    this.skills = Array.isArray(res.data)?res.data:[];
                }else{
                    this.$message.error(JSON.stringify(res.message));
                }
            });
            
        },
        //
        coursePhase(id,sportsKindId) {
            this.$get('/course/queryCourseDetailById', {id}).then(res => {
                if (res.code == 0) {
                    this.$nextTick(function() {
                        this.stageData = res.data;
                    });
                }else{
                    this.$message.error(JSON.stringify(res.message));
                }
            });
            this.$get('/coursePhase/' + id)
                .then(res => {
                    if (res.code == 0) {
                        let list = Array.isArray(res.data)?res.data:[],newArr=[],addListJson=null;
                        if(sportsKindId == 1){//单车
                            addListJson=this.stageSection.bicycle;
                        }else if(sportsKindId == 2){ //跑步机
                            addListJson=this.stageSection.run;
                        }else if(sportsKindId == 3){ //椭圆机
                            addListJson=this.stageSection.ellipticalMachine;
                        }else if(sportsKindId == 4){ //划船机
                            addListJson=this.stageSection.rowingMachine;
                        }else{
                            addListJson=this.stageSection.other;
                        }
                        console.log('addListJson',addListJson)
                        addListJson=Object.keys(addListJson);
                        list.forEach((item,index)=>{ 
                            let obj={
                                phase:item.phase?Number(item.phase):(index+1),
                                courseId: id,
                            };
                            addListJson.forEach(val=>{
                                obj[val]=item[val];
                            })
                            newArr.push(obj)
                        })
                        console.log('newArr',newArr)
                        this.coursePhaseData=newArr;
                        this.activeClass='1';
                        this.dialogVisible3 = true;
                        setTimeout(()=>this.handleClassClick1(),500)
                    } else {
                        this.$message.error(JSON.stringify(res.message));
                    }
                })
        },
        addLine() {
            //添加行数
            let newValue = {
               courseId: this.stageData.id,
               phase:this.coursePhaseData.length+1,
            },addListJson=null;
            if(this.courseSportsKindId == 1){//单车
                addListJson=this.stageSection.bicycle;
            }else if(this.courseSportsKindId == 2){ //跑步机
                addListJson=this.stageSection.run;
            }else if(this.courseSportsKindId == 3){ //椭圆机
                addListJson=this.stageSection.ellipticalMachine;
            }else if(this.courseSportsKindId == 4){ //划船机
                addListJson=this.stageSection.rowingMachine;
            }else{
                addListJson=this.stageSection.other;
            }
            addListJson=Object.keys(addListJson);
            addListJson.forEach(item=>{
                newValue[item]='';
            })
            //添加新的行数
            this.coursePhaseData.push(newValue);
        },
        delLine(index) {
            //删除行数
            this.coursePhaseData.splice(index,1)
            this.coursePhaseData.forEach((item,index)=>{
                item.phase=index+1;
            })
        },
        stageCopy(data,index,flag){
            // flag 1 向上复制 2,向下复制
            let pushData=this.$_.cloneDeep(this.coursePhaseData)
            if(flag == 1){
                pushData.splice(index,0,data)
            }else{
                pushData.splice(index+1,0,data)
            }
           pushData.forEach((item,index)=>{
                item.phase=index+1;
            })
            this.coursePhaseData=pushData;
        },
        videoStick(row) {
            //置顶
            var params = {
                courseId: row.id
            };
            this.$post('/course/addCourseStick', JSON.stringify(params)).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.pageNum = 1;
                    this.currentRow = '';
                    this.page();
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        showEacharts(xData,yData,element,infos,title='心率'){
            var myChart = echarts.init(element);
            const option = {
                    title: {
                        text: '课程阶段'+title,
                        subtext: title
                    },
                    xAxis: [
                        {
                        type: 'category',
                        data: xData
                        }
                    ],
                    grid: {
                        left: '1%',
                        right: '4%',
                        bottom: '0%',
                        top: '13%',
                        containLabel: true
                    },
                    yAxis: [
                        {
                            type: 'value',
                            min:infos[infos.length-1].min,
                            max:infos[0].max,
                            splitNumber:infos.length,
                        }
                    ],
                    series: [
                        {
                        name: 'Rainfall',
                        type: 'bar',
                        data: yData,
                        label:{
                            show: true,
                            distance:20,
                            position:'top',
                            align: 'center',
                            verticalAlign: 'top',
                            formatter: '{c}%',
                        },
                        itemStyle: {
                                normal: {
                                    color: function(params) {
                                        let color='';
                                        for(let i=0;i<infos.length;i++){
                                            if(params.data>=infos[i].min && params.data<=infos[i].max){
                                                color=infos[i].color;
                                                break;
                                            }
                                        }
                                        return color;
                                    }
                                }
                            }
                        },
                    ]
            };
            myChart.setOption(option);
        }
    }
};
</script>

<style scoped>
::deep .avatar-uploader-icon {
    width: 108px;
    line-height: 108px;
}
.selectUser {
    color: #409eff;
}
.selectUser label,
.selectUser i {
    font-size: 12px;
}

::deep .stagecon .el-dialog__body {
    padding: 10px 20px;
}
::deep .el-date-editor .el-range-separator {
    padding: 0;
}
.searchBtn .el-range-editor.el-input__inner {
    margin: 0 15px;
}
.topinput {
    position: relative;
    margin-left: 15px;
    width: 250px;
}
.topinput input {
    font-size: 13px;
}
.nickNameul {
    position: absolute;
    background: #fff;
    width: 100%;
    padding: 10px;
    font-size: 13px;
    line-height: 25px;
    border: 1px solid #dcdfe6;
    border-top: none;
}
.nickNameul li {
    color: #666;
    cursor: pointer;
}
.nickNameul li:hover {
    color: #409eff;
}
.coaches-list{
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
}
.coaches-list-item{
    width: 25%;
    padding:6px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.eachart-box{
    padding-left:120px;
    position: relative;
}
.eachart-box-bar{
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    width: 120px;
}
.eachart-box-progress{ 
    display: flex;
    align-items: center;
}
.eachart-box-progress-text{
    font-size: 12px;
    color:#333;
    flex:1;
    text-align: right;
    padding-right: 4px;
}
.eachart-box-progress-line{
    width: 8px;
    height: 100%;
}
.drag-col{
    padding:4px;
    height: 30px;
    text-align: center;
    font-size: 14px;
    color:#333;
    font-weight: bold;
    line-height: 30px;
}
.drag-table{
    width: 100%;
}
.drag-table table{
    width: 100%;
    border-collapse: collapse;
}
.drag-table table tr td{
    text-align: center;
    border:1px solid #eee;
    height: 40px;
    line-height: 40px;
    padding:3px;
}
.drag-table .header{
    width: 100%;
}
.drag-table .header td{
    font-size: 14px;
    font-weight: bold;
    color:#666;

}
.drag-table table div{
   display: inline-table;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/coursesList/index.vue